// assets
import {
  AppstoreAddOutlined,
  AntDesignOutlined,
  BarcodeOutlined,
  BgColorsOutlined,
  FontSizeOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import PeopleIcon from '@mui/icons-material/People';
import CreditCardIcon from '@mui/icons-material/CreditCard';

// icons
const icons = {
  FontSizeOutlined,
  BgColorsOutlined,
  BarcodeOutlined,
  AntDesignOutlined,
  LoadingOutlined,
  AppstoreAddOutlined,
  PeopleIcon
};

// ==============================|| MENU ITEMS - UTILITIES ||============================== //

const utilities = {
  id: 'utilities',
  title: 'Utilities',
  type: 'group',
  children: [
    {
      id: 'employees',
      title: 'Employees',
      type: 'item',
      url: '/employees',
      icon: icons.PeopleIcon
    },
    {
      id: 'substores',
      title: 'Sub Stores',
      type: 'item',
      url: '/substores',
      icon: icons.AppstoreAddOutlined
    },
    {
      id: 'employee-dashboard',
      title: 'Employee Dashboard',
      type: 'item',
      url: '/employee-dashboard',
      icon: icons.PeopleIcon
    }
  ]
};

export default utilities;
